import { combineReducers } from "redux";
// import all reducers
import alertReducer from "neon-frontend-utils/src/components/Alert/reducers/alert";
import formReducer from "neon-frontend-utils/src/components/Form/reducers/form";
import switchLanguageReducer from "./components/SwitchLanguage/reducers/switchLanguage";
import featureToggleReducer from "./pages/FeatureToggles/reducers/featuretoggles";
import financeReducer from "./pages/Finance/reducers/finance";
import questionnaireBuilderReducer from "./pages/LtpSettings/components/QuestionnaireBuilder/reducers/questionnairebuilder";
import addUserReducer from "./pages/OrganisationSettings/components/AddUser/reducers/adduser";
import organisationSettingsReducer from "./pages/OrganisationSettings/reducers/organisationSettings";
import participantsFilterReducer from "./pages/Participants/components/FilterMenu/reducers/filtermenu";
import participantsReducer from "./pages/Participants/reducers/participants";
import reportReducer from "./pages/Report/reducers/report";
import resultsReducer from "./pages/Results/reducers/results";

// combine into one
const rootReducer = combineReducers({
    addUserReducer,
    alertReducer,
    featureToggleReducer,
    financeReducer,
    formReducer,
    organisationSettingsReducer,
    participantsFilterReducer,
    participantsReducer,
    questionnaireBuilderReducer,
    reportReducer,
    resultsReducer,
    switchLanguageReducer,
});

export default rootReducer;
